import getStore from '../store/store';

export function getTimePanelSessionId(): string {
    return getStore().sessionId;
}
